module.exports = __webpack_public_path__ + "img/btn_menu-close.9c1e16ce.png";